import { createListFilters } from '../../../../../components'

export type DownloadAsoFilters = {
  paciente: string
  protocolo: string
  /** Data pura (aaaa-mm-dd): consulta ASO finalizada a partir de. */
  fim: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<DownloadAsoFilters>({
  paciente: '',
  protocolo: '',
  fim: '',
})
